import classNames from 'classnames'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Body1, Body2, Caption1, Heading6 } from '@ui/Typography'

import { MultiLevelCommissionDetailDto } from '@model/MultiLevelCommission'

import { ConfettiIcon } from '../../../assets/Confetti.icon'
import { LevelFireIcon } from '../../../assets/LevelFire.icon'
import { iconByLevel } from '../../constants/multiLevelCommission'

import styles from './NewLevelBanner.module.scss'

interface NewLevelBannerProps {
  multiLevelData: MultiLevelCommissionDetailDto
  onHideClick: () => void
}

export const NewLevelBanner: FC<NewLevelBannerProps> = (props) => {
  const { multiLevelData, onHideClick } = props
  const { levels } = multiLevelData
  type levelType = 2 | 3 | 4 | 5 | 6
  const currentLevel: levelType = levels.current.id as levelType
  const hasReachedMaxLevel = currentLevel === levels.final.id

  const Icon = iconByLevel[currentLevel]

  const { t } = useTranslation()

  return (
    <div
      className={classNames(styles.newLevelBanner, {
        [styles[`level${currentLevel}`]]: currentLevel,
        [styles.maxLevel]: hasReachedMaxLevel,
      })}
    >
      <div className={styles.iconsWrapper}>
        <ConfettiIcon className={styles.confetti} size={!hasReachedMaxLevel ? 145 : undefined} />
        <Icon size={hasReachedMaxLevel ? 66 : 75} />
      </div>

      <div className={styles.inner}>
        <div className={styles.textWrapper}>
          <Heading6 className={styles.title} medium>
            {t('IB.Dashboard.Congratulations! 🎉')}
          </Heading6>
          <div>
            {hasReachedMaxLevel ? (
              <Body1 className={styles.text}>
                {t('IB.Dashboard.You reached the maximum level')}
              </Body1>
            ) : (
              <>
                <Body1 className={styles.text} medium>
                  {t('IB.Dashboard.New level unlocked!')}
                </Body1>{' '}
                <Body1 className={styles.text}>
                  {t('IB.Dashboard.Keep pushing — the best is yet to come! 💪 🚀')}
                </Body1>
              </>
            )}
          </div>
        </div>
        {hasReachedMaxLevel ? (
          <LevelFireIcon size={55} className={styles.maxLevelIcon} />
        ) : (
          <button
            className={styles.hideButton}
            onClick={() => multiLevelData.canHideNotification && onHideClick()}
          >
            <Body2 medium className={styles.hideDesktop}>
              {t('IB.Dashboard.HIDE')}
            </Body2>
            <Caption1 medium className={styles.hideMobile}>
              {t('IB.Dashboard.HIDE')}
            </Caption1>
          </button>
        )}
      </div>
    </div>
  )
}
